export const ACTIVE_USER_ID_COOKIE = "activeUserId";
export const AUTH_TOKEN_COOKIE = "token";
